import UrlParameter from '@shared/utils/url/UrlParameter'

export function formatSum(sum, toIntIfNoPlaces = true, currency = '$', formatCurrency = false) {
  void toIntIfNoPlaces
  let numeric = Number(sum)

  if (Number.isNaN(numeric)) {
    numeric = 0
  }

  let isNegative = numeric < 0
  let absolute = Math.abs(numeric)

  let formatted = number_format(absolute, 2, '.', ',')

  if (currency && formatCurrency) {
    currency = getCurrencySign(currency)
  } else if (!currency) {
    currency = ''
  }

  const result = `${currency}${formatted}`

  return isNegative ? `-${result}` : result
}

export function getCurrencySign(code) {
  return {USD: '$', EUR: '€', GBP: '£'}[code]
}

export function toIntegerIfNoPlaces(value) {
  return isInteger(parseFloat(value)) ? parseInt(value) : value
}

export function isInteger(value) {
  if (typeof value !== 'number') {
    return false
  }

  return Math.floor(value) === value
}

export function deleteEmptyObjectKeys(obj) {
  Object.keys(obj).forEach(key => {
    if (obj[key] === null || obj[key] === '' || obj[key] === undefined) {
      delete obj[key]
    }
  })

  return obj
}

export const http_build_query = function (formdata, numeric_prefix, arg_separator, url_decode) {
  var value,
    key,
    tmp = []

  if (url_decode === undefined) url_decode = true

  var _http_build_query_helper = function (key, val, arg_separator) {
    var k,
      tmp = []
    if (val === true) {
      val = '1'
    } else if (val === false) {
      val = '0'
    }
    if (val != null) {
      if (typeof val === 'object') {
        for (k in val) {
          if (val[k] != null) {
            tmp.push(_http_build_query_helper(key + '[' + k + ']', val[k], arg_separator))
          }
        }
        return tmp.join(arg_separator)
      } else if (typeof val !== 'function') {
        if (url_decode) {
          return encodeURIComponent(key) + '=' + encodeURIComponent(val)
        } else {
          return key + '=' + val
        }
      } else {
        throw new Error('There was an error processing for http_build_query().')
      }
    } else {
      return ''
    }
  }

  if (!arg_separator) {
    arg_separator = '&'
  }
  for (key in formdata) {
    value = formdata[key]
    if (numeric_prefix && !isNaN(key)) {
      key = String(numeric_prefix) + key
    }
    var query = _http_build_query_helper(key, value, arg_separator)
    if (query !== '') {
      tmp.push(query)
    }
  }

  return tmp.join(arg_separator)
}

export const number_format = function (number, decimals = 2, dec_point = '.', thousands_sep = ',') {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point,
    s = '',
    toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + (Math.round(n * k) / k).toFixed(prec)
    }

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || ''
    s[1] += new Array(prec - s[1].length + 1).join('0')
  }
  return s.join(dec)
}

function safePushState(url) {
  const state = history.state || {}
  history.pushState({...state}, '', url)
}

function safeReplaceState(url) {
  const state = history.state || {}
  history.replaceState({...state}, '', url)
}

export const insertValueInUrl = function (param, value) {
  if (param === undefined) return false
  if (value === undefined) return false

  const url = new URL(window.location.href)
  url.searchParams.set(param, String(value))

  safePushState(url.pathname + url.search)
  return true
}

export const removeParamFromUrl = function (param) {
  const url = new URL(window.location.href)
  url.searchParams.delete(param)

  safeReplaceState(url.pathname + url.search)
}

export const getUrlVars = function () {
  var vars = {}
  var href = decodeURI(window.location.href)
  var answer_position = href.indexOf('?')
  var hash_position = href.indexOf('#')

  if (answer_position < 0 && hash_position > 0) {
    href = href.replace('#', '?')
    answer_position = hash_position
  }
  if (answer_position > 0 && hash_position > 0) {
    href = href.replace('#', '&')
  }
  var hashes = href.slice(answer_position + 1).split('&')
  for (var i = 0; i < hashes.length; i++) {
    var part = hashes[i].split('=')
    // vars.push(part[0]);
    vars[part[0]] = part[1]
  }

  return vars
}

export function replaceQueryParam(param, value) {
  if (param === undefined) {
    console.error('param is undefined')
    return false
  }

  if (value === undefined) {
    console.error('value is undefined')
    return false
  }

  var query_string = location.search
  var reg = new RegExp('([?|&])' + param + '=(.*?)[^&]*', 'gi')

  //Замена
  var new_query_string = query_string.replace(reg, '$1' + param + '=' + value)
  if (new_query_string == '') {
    history.pushState('', '', '?' + param + '=' + value)
  } else {
    //Запись в адресную строку
    setQueryString(new_query_string.substr(1))
  }

  return true
}

export function setQueryString(query) {
  if (typeof query !== 'string') {
    return
  }

  if (query == '') {
    return
  }

  if (history.replaceState) history.replaceState(null, null, '?' + query)
  else location.href = '#' + query
}

export function formatCreatedAt(created_at) {
  return typeof created_at === 'string' ? created_at.split(' ').shift() : ''
}

export function setPageTitle(route) {
  const title = typeof route.meta?.title === 'function' ? route.meta.title(route) : route.meta?.title
  document.title = title ? title + ' - PointBoard' : 'PointBoard'
}

export function isLocal() {
  return process.env.VUE_APP_ENV === 'local'
}

export function isDev() {
  return process.env.VUE_APP_ENV === 'dev'
}

export function isStaging() {
  return process.env.VUE_APP_ENV === 'staging'
}

export function isProduction() {
  return process.env.VUE_APP_ENV === 'production'
}

export function openUrl(url) {
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function setOnBeforeUnloadCallback() {
  window.onbeforeunload = function (e) {
    e.preventDefault
    return 'Reloaded'
  }
}

export function resetOnBeforeUnloadCallback() {
  return (window.onbeforeunload = null)
}

export function removeObjectFromArray(index, array) {
  array.splice(index, 1)
}

export function loadExternalScript(url) {
  let script = document.createElement('script')
  script.setAttribute('src', url)
  document.head.appendChild(script)
}

export function isEqualTo(a, b) {
  return a === b
}

export function callManyActions(fn, amount, delay = 1000) {
  let counter = 0
  return function (...args) {
    let timer = setInterval(() => {
      if (amount === counter) {
        clearInterval(timer)
        console.log('FINISHED')
      } else {
        counter++
        console.log(counter)
        fn.apply(this, ...args)
      }
    }, delay)
  }
}
export function hideElementIfExist(element_id) {
  if (document.getElementById(element_id)) {
    document.getElementById(element_id).style.display = 'none'
  }
}

export function showElementIfExist(element_id) {
  if (document.getElementById(element_id)) {
    document.getElementById(element_id).style.display = 'block'
  }
}

export function getCompanyInvoicePdf(invoice_hash) {
  window.open(`${process.env.VUE_APP_API_URL}/company-invoices/${invoice_hash}/pdf`)
}

export function formatCapitalizeAndSplit(value) {
  if (!value) {
    return
  }

  let words = value.split('_')

  let formattedValue = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')

  return formattedValue
}

export function getFirstTwoInitials(str) {
  const words = str.trim().split(/\s+/)

  const firstWord = words[0] || ''
  const secondWord = words[1] || ''

  return firstWord.charAt(0).toUpperCase() + secondWord.charAt(0).toUpperCase()
}

export function formatPlatformToLowercase(platform) {
  if (!platform) {
    return
  }

  if (['smart_news', 'smart news'].includes(platform)) {
    return 'smartnews'
  }

  if (['Facebook', 'facebook'].includes(platform)) {
    return 'meta'
  }

  if (['Microsoft', 'microsoft', 'Microsoft Ads'].includes(platform)) {
    return 'bing'
  }

  return platform.toLowerCase()
}

export function formatBingToMicrosoftLowercase(platform) {
  if (!platform) {
    return
  }

  if (['Bing', 'bing'].includes(platform)) {
    return 'microsoft'
  }

  if (['Facebook', 'facebook'].includes(platform)) {
    return 'meta'
  }

  return platform.toLowerCase()
}

export function formatPlatformToLabel(platform) {
  if (['Facebook', 'facebook'].includes(platform)) {
    return 'Meta'
  }

  if (['Microsoft', 'microsoft', 'Bing', 'bing'].includes(platform)) {
    return 'Microsoft Ads'
  }

  if (['Newsbreak', 'newsbreak'].includes(platform)) {
    return 'NewsBreak'
  }

  if (['Tiktok', 'tiktok'].includes(platform)) {
    return 'TikTok'
  }

  if (['Rollerads'].includes(platform)) {
    return 'RollerAds'
  }

  if (['SmartNews', 'Smartnews'].includes(platform)) {
    return 'Smart News'
  }

  if (['Bigo', 'bigo'].includes(platform)) {
    return 'Bigo Ads'
  }

  if (['Mintegral', 'mintegral'].includes(platform)) {
    return 'Mintegral'
  }

  if (['Mediago', 'mediago', 'MediaGO', 'mediaGO'].includes(platform)) {
    return 'MediaGo'
  }

  return formatCapitalizeAndSplit(platform)
}

export function filterKeysByDefaults(data, defaults) {
  return Object.keys(data).reduce((acc, key) => {
    if (key in defaults) {
      acc[key] = data[key]
    }
    return acc
  }, {})
}

export function filterNumbers(value) {
  return String(value).replace(/[^\d.-]+/g, '')
}

export function isImageType(fileType) {
  return fileType && fileType.startsWith('image/')
}

export function isVideoType(fileType) {
  return fileType && fileType.startsWith('video/')
}

export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

export function toLowercaseAndJoin(string) {
  return string.toLowerCase().split(' ').join('_')
}

export function getUTMParams(utmFields) {
  const urlParams = new URLSearchParams(window.location.search)
  return Object.fromEntries(utmFields.filter(field => urlParams.has(field)).map(field => [field, urlParams.get(field)]))
}

export function removeUTMParams(utmFields) {
  const url = new URL(window.location)
  utmFields.forEach(field => {
    url.searchParams.delete(field)
  })
  window.history.replaceState({}, document.title, url.pathname + url.search)
}

export function parseStringNewLineToArray(str) {
  return str
    .split('\n')
    .map(line => line.trim())
    .filter(line => line !== '')
}

export function parseStringCommaJoinToArray(str) {
  return str
    .split(',')
    .map(item => item.trim())
    .filter(item => item !== '')
}

export function parseArrayToNewlineString(arr) {
  return arr.join('\n')
}

export function parseArrayToCommaJoinString(arr) {
  return arr.join(', ')
}

export function convertBooleanToNumber(value) {
  return value === true ? 1 : value === false ? 0 : undefined
}

export function normalizeEmails(values) {
  return values.map(email => email.trim().toLowerCase())
}

export function findInvalidEmails(values) {
  return values.filter(email => !isValidEmail(email))
}

export function arraysEqual(a, b) {
  if (a.length !== b.length) {
    return false
  }
  return a.every((value, index) => value === b[index])
}

export function formatStringEmailsToCommaJoin(input) {
  return input.trim().split(/\s+/).join(', ')
}

export function formatEmailsToCommaJoinString(emails) {
  if (!emails) {
    return ''
  }

  return emails
    .split(/[\s,;]+/)
    .map(email => email.trim().replace(/^[.,;:'"<>()[\]{}\s]+|[.,;:'"<>()[\]{}\s]+$/g, ''))
    .filter(email => isValidEmail(email))
    .join(',')
}

export function isPositiveNumber(value) {
  return typeof value === 'number' && !isNaN(value) && value > 0
}

export function cleanupLocalStorage() {
  const keysToRemove = [
    'hide-done-filter',
    'company-filter',
    'unit-filter',
    'current-source',
    'responsible-filter',
    'per-page-pagination',
    'user-token',
    'home-widgets-layout',
  ]

  keysToRemove.forEach(key => {
    if (localStorage.getItem(key) !== null) {
      localStorage.removeItem(key)
    }
  })
}

export function isEmpty(v) {
  return v === null || v === undefined || v === '' || (typeof v === 'number' && Number.isNaN(v))
}

export function toggleLocalStorage(name, value) {
  if (isEmpty(value)) {
    return localStorage.removeItem(name)
  }

  const currentValue = localStorage.getItem(name)
  if (currentValue === String(value)) {
    return
  }

  localStorage.setItem(name, String(value))
}

export function toggleUrlParameter(param, value) {
  if (isEmpty(value)) {
    return UrlParameter.removeParam(param)
  }

  const currentValue = UrlParameter.getParam(param)
  if (currentValue === String(value)) {
    return
  }

  UrlParameter.setParam(param, value)
}

export function storeFilter(url_param, param, value) {
  toggleUrlParameter(url_param, value)
  toggleLocalStorage(param, value)
}

export function getUrlOrLocalStorageItem(url_param, param, type = 'string') {
  const fromUrl = UrlParameter.getParam(url_param)
  if (fromUrl !== null && fromUrl !== undefined) {
    return fromUrl
  }

  const value = type === 'number' ? getNumberFromLocalStorage(param) : localStorage.getItem(param)

  if (typeof value === 'number' && Number.isNaN(value)) {
    return undefined
  }

  return value
}

export function formatThousands(n) {
  if (n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  }
}

export const FACEBOOK_URL_REGEX = /^https?:\/\/([a-z0-9-]+\.)*(facebook\.com|fb\.com|fb\.me)\/\S+$/i

export function isFacebookUrl(url) {
  return FACEBOOK_URL_REGEX.test(String(url ?? '').trim())
}

export function validateLinksTextarea(input) {
  if (!input) {
    return false
  }

  const items = input
    .split(/[\n,]/)
    .map(i => i.trim())
    .filter(i => i.length > 0)

  const httpsRegex = /^https:\/\/[^\s/$.?#].[^\s]*$/i

  return items.length > 0 && items.every(item => httpsRegex.test(item))
}

export function getNumberFromLocalStorage(key) {
  const raw = localStorage.getItem(key)

  if (raw === null || raw.trim() === '') return undefined

  const n = Number(raw)

  return n === 0 || n === 1 ? n : undefined
}
export function getValidationError(errors) {
  let formatted = ''

  for (let field in errors) {
    for (let item in errors[field]) {
      if (errors[field][item] !== '') {
        formatted += errors[field][item] + '\n'
      }
    }
  }

  return formatted
}
